import axios from "axios"
import { Token } from "../components/urlParams";
import { REACT_APP_USER_API_URL } from "../envVariables";



export const getUserDetails = async () => {
    try {
        const rawUrl = REACT_APP_USER_API_URL || process.env.REACT_APP_USER_API_URL || '';
        const baseUrl = rawUrl ? (rawUrl.endsWith('/') ? rawUrl : `${rawUrl}/`) : '/api/v1/';
        const responce = await axios.get(`${baseUrl}user/get-user`, {
            headers: {
                'Authorization': `AccessToken=${Token}`,
                'Content-Type': 'application/json',
            }
        })
        return responce.data.data;
    } catch (err) {
        console.log('getting error get user', err)
    }
}